import {
  AvailabilityPreferencesV3ArmMapping,
  ExperimentPlatformTypes,
  ExperimentUUIDs,
  MemberPreferencesPageLocation,
  MultiplePrimaryNeedsArmMapping,
  ProviderResultsRedesignArmMapping,
  S4CHomebaseHeaderQ12025Actions,
  S4CHomebaseHeaderQ12025ArmMapping,
  UrgencyToBookArmMapping,
  UrgencyToBookV2PageLocation,
} from './types'
import { PrimaryNeedOptions } from '../../models/searchForCare/SearchForCare'
import { WELLNESS_TOOLKIT_PROMOTION } from '../wellnessToolkit/types'

export interface CommonExperimentJoinKeys {
  client_lyra_id: string
  session_id?: string
}

export interface SearchForCareHomebaseHeaderExperimentJoinKeys extends CommonExperimentJoinKeys {
  device_uuid: string
  metric: SEARCH_FOR_CARE_HOMEBASE_METRICS
  description: string
  detected_country: string
  customer_name: string
}

export enum SEARCH_FOR_CARE_HOMEBASE_METRICS {
  VIEW_HOMEBASE = 'view homebase header',
}

export enum SEARCH_FOR_CARE_HOMEBASE_DESCRIPTIONS {
  HOMEBASE = 'When user lands on homebase',
}

interface CommonExperimentParams {
  client_lyra_id: string
  device_uuid: string
}

export interface GenerateSearchForHeaderHomebaseExperimentPayloadParams extends CommonExperimentParams {
  arm: string
  metric: SEARCH_FOR_CARE_HOMEBASE_METRICS
  customer_name: string
  description: SEARCH_FOR_CARE_HOMEBASE_DESCRIPTIONS
  detected_country: string
}

export interface AvailabilityPreferenceV3ExperimentPayloadParams extends CommonExperimentParams {
  arm: AvailabilityPreferencesV3ArmMapping
  search_id: string
  page_location: MemberPreferencesPageLocation
}

export interface AvailabilityPreferenceV3ExperimentJoinKeys extends CommonExperimentJoinKeys {
  search_id: string
  page_location: MemberPreferencesPageLocation
}

export interface UrgencyToBookExperimentPayloadParams extends CommonExperimentParams {
  provider_id: string
  matcher_request_id: string
  search_id: string
  arm: UrgencyToBookArmMapping
  page_location: UrgencyToBookV2PageLocation
}

export interface UrgencyToBookExperimentJoinKeys extends CommonExperimentJoinKeys {
  provider_id: string
  matcher_request_id: string // search request id (aka userFavoriteProviderRequestId)
  search_id: string // triage search id
  page_location: UrgencyToBookV2PageLocation
}

export interface S4CHomebaseHeaderQ12025JoinKeys extends CommonExperimentJoinKeys {
  action: S4CHomebaseHeaderQ12025Actions // action taken on homebase
  search_id: string // triage search id
  triage_need: string | PrimaryNeedOptions // selected primary care option
  toolkit_topic: string // selected toolkit from toolkit carousel on homebase
  patient: string // selected patient from dropdown i.e. self or child

  // indicates whether user has already started a self search, can be used to determine if the continue version of header is being shown
  has_started_search_for_self: boolean
}

export interface S4CHomebaseHeaderQ12025PayloadParams extends CommonExperimentParams {
  arm: S4CHomebaseHeaderQ12025ArmMapping
  action: S4CHomebaseHeaderQ12025Actions
  search_id?: string
  triage_need?: string | PrimaryNeedOptions
  toolkit_topic?: string
  patient?: string
  has_started_search_for_self?: boolean
}

export enum MULTIPLE_PRIMARY_NEEDS_ORIGINS {
  HOMEBASE = 'homebase',
  PRIMARY_NEED_SCREENER = 'primary need screener',
}
export interface MultiplePrimaryNeedsJoinKeys extends CommonExperimentJoinKeys {
  client_lyra_id: string
  device_uuid: string
  customer_name: string
  search_id?: string | null
  origin: MULTIPLE_PRIMARY_NEEDS_ORIGINS
}

export interface MultiplePrimaryNeedsPayloadParams extends CommonExperimentParams {
  arm: MultiplePrimaryNeedsArmMapping
  search_id?: string | null
  customer_name?: string
  origin: MULTIPLE_PRIMARY_NEEDS_ORIGINS
}
export interface ProviderResultsRedesignExperimentPayloadParams extends CommonExperimentParams {
  matcher_request_id: string
  search_id: string
  arm: ProviderResultsRedesignArmMapping
  platform: ExperimentPlatformTypes
}

export interface ProgramAwareTriageExperimentPayloadParams extends CommonExperimentParams {
  selectedToolkitTopic: WELLNESS_TOOLKIT_PROMOTION
  arm: 'treatment' | 'control'
}

export interface GenericExperimentPayloadParams {
  experimentUUID: ExperimentUUIDs
  deviceUUID: string
  joinKeys: CommonExperimentJoinKeys
  platform?: ExperimentPlatformTypes
  flagName?: string
  flagValue?: string
}
